export const PHONE_MAIN = "0786 804 728";
export const PHONE_MAIN_TEL = "+40786804728";
export const PHONE_SECOND = "0786 804 729";
export const PHONE_SECOND_TEL = "+40786804729";
export const PHONE_LANDLINE = "0256 706 396";
export const PHONE_LANDLINE_TEL = "+40256706396";
export const EMAIL = "speedshopauto@yahoo.com";
export const ADDRESS = "G. Dragalina nr. 27, Timișoara";
